import { Component, Input } from '@angular/core';

@Component({
  selector: 'nobis-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  private typeIconBaseUrl: string = './../../../../assets/svg/';

  @Input() title?: string;
  @Input() content?: string;
  @Input() type: 'info' | 'alert' | 'none' = 'info';
  @Input() imgWidth? = 58;
  @Input() imgHeight? = 58;
  @Input() titleOnly: boolean = false;

  get typeIconRoute(): string {
    return `${this.typeIconBaseUrl}${this.type}.svg`
  }
}
